import { render } from "./Donations.vue?vue&type=template&id=3d049f68"
import script from "./Donations.vue?vue&type=script&lang=js"
export * from "./Donations.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__